import './App.scss';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ErrorPage from './ErrorPage';
import { appInsights } from './Services/AppInsights';
import Dashboard from './Dashboard/Dashboard';
import { AuthProvider } from './Auth/AuthProvider';
import { AuthorizeRoute } from './Auth/AuthorizeRoute';
import { Fragment } from 'react';
import { Callback } from './Auth/Callback';
import { Login } from './Auth/Login';
import { Logout } from './Auth/Logout';
import { LogoutCallback } from './Auth/LogoutCallback';
import { ApplicationPaths } from './Services/Auth/AuthConstants';
import { StaffOnlyRoute } from './Auth/StaffOnlyRoute';
import { OnBehalfOf } from './Auth/OnBehalfOf';
import { PreCertPaths } from './Shared/Utility/PreCertLocationHelper';
import Layout from './Layout/Components/Layout';
import UnauthorizedPage from './UnauthorizedPage';
import { ActiveRoster } from './Dashboard/ActiveRoster';
import { AlumniRoster } from './Dashboard/AlumniRoster';
import { TransferResidents } from './Dashboard/TransferResidents';
import { Reports } from './Dashboard/Reports';
import { Requirements } from './Dashboard/ProgramRequirements';
import NotFoundPage from './NotFoundPage';
import { ActiveRosterProvider } from './Contexts/ActiveRosterProvider';
import { AlumniRosterProvider } from './Contexts/AlumniRosterProvider';
import { ActiveResident } from './Dashboard/ActiveResident';
import { AlumniResident } from './Dashboard/AlumniDetail';
import ResidentInformationForm from './Residents/Components/ResidentInformationForm';

function App() {
  appInsights.load();

  return (
    <AuthProvider>
      <BrowserRouter basename={PreCertPaths.BaseName}>
        <Routes>
          {/* Authorization Routes */}
          <Fragment>
            <Route path={ApplicationPaths.LoginCallback} element={<Callback />} />
            <Route path={`${ApplicationPaths.Login}/:emailAddress?/:redirectUrl?`} element={<Login />} />
            <Route path={ApplicationPaths.LogOut} element={<Logout />} />
            <Route path={ApplicationPaths.LogOutCallback} element={<LogoutCallback />} />
            <Route path={`${ApplicationPaths.OnBehalfOf}/:preCertUserId/:physicianId`} element={<StaffOnlyRoute><OnBehalfOf /></StaffOnlyRoute>} />
            <Route path={`${ApplicationPaths.OnBehalfOf}/:preCertUserId/`} element={<StaffOnlyRoute><OnBehalfOf /></StaffOnlyRoute>} />
          </Fragment>

          {/* Authorized Routes */}
          <Route element={<Layout />}>
            <Route element={<AuthorizeRoute><Dashboard /></AuthorizeRoute>}>
              <Route path="Alumni/:physicianId" element={<AlumniRosterProvider><AlumniResident /></AlumniRosterProvider>} />
              <Route path="Alumni/*" element={<AlumniRosterProvider><AlumniRoster /></AlumniRosterProvider>} />
              <Route path="Transfer" element={<TransferResidents />} />
              <Route path="Reports" element={<Reports />} />
              <Route path="Requirements" element={<Requirements />} />
              <Route path=":physicianId" element={<ActiveRosterProvider><ActiveResident /></ActiveRosterProvider>} />
              <Route path="Edit/:physicianId" element={<ResidentInformationForm />} />
              <Route path="New" element={<ResidentInformationForm />} />
              <Route path="/*" element={<ActiveRosterProvider><ActiveRoster /></ActiveRosterProvider>} />
            </Route>

            {/* Error Page */}
            <Route path={PreCertPaths.ErrorPage} element={<ErrorPage />} />
            <Route path={PreCertPaths.NotFound} element={<NotFoundPage />} />
            <Route path={PreCertPaths.UnauthorizedPage} element={<UnauthorizedPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
